<style scoped lang="scss">
    .as_popup {
        width:100%;
        height:100%;
        overflow:hidden;
        background:#fff;
        .van-nav-bar {
            position:fixed; 
            top:0;
            left:0;
            width:100%;
            height: 46px;
        }
        .cmain {
            height: calc(100% - 46px);
            overflow-y: auto;
        }
        .van-cell {
            margin-top: 0;
        }
        .van-cell__title{
            text-align: center;
            font-weight: normal;
        }
        .van-cell:not(:last-child)::after { 
            left:0;
            border-bottom: 1px solid #ebedf0;
        }
        .van-tree-select {
            height: 100%!important;
        }
    }
</style>
<template>
    <van-popup class="as_popup Show" v-model="isShowPopup" position="bottom">
        <van-nav-bar
            :title="showBrandOrCate == 1 ? '商品品牌' : '商品分类'"
            left-text=""
            left-arrow
            @click-left="closePopup"
        />
        <div class="cmain">
            <template v-if="showBrandOrCate == 1">
                <van-list
                    v-model="brandLoading"
                    :finished="brandFinished"
                    finished-text="没有更多了"
                >
                    <van-cell
                        v-for="item in brandList"
                        :key="item.id"
                        :title="item.text"
                        :to="{path:'/m/data', query:{brandId:item.id, title:item.text}}"
                    />
                </van-list>
            </template>
            <template v-if="showBrandOrCate == 2">
                <van-tree-select
                    :items="items"
                    :main-active-index="mainActiveIndex"
                    :active-id="activeId"
                    @navclick="onNavClick"
                    @itemclick="onItemClick"
                />
            </template>
        </div>
    </van-popup>
</template>

<script>
    export default {
        name: 'brandOrCategories',
        props: {
            'showPopup': {
                default: false,
                type: Boolean
            },
            'showBrandOrCate': {
                default: 1,
                type: Number
            }
        },
        data () {
            return {
                isShowPopup: this.showPopup,
                //商品品牌
                brandList: [],
                brandLoading: false,
                brandFinished: true,
                //分类
                items:[],
                mainActiveIndex: 0, // 左侧高亮元素的index
                activeId: 0 // 被选中元素的id
            }
        },
        mounted () {
            this.getCategoriesAndBrands();
        },
        watch: {
            showPopup(val) {
                this.isShowPopup = val;
            }
        },
        methods: {
            onNavClick(index) {
                this.mainActiveIndex = index;
                if (this.items.length > 0 && this.items[index].children.length > 0) {
                    this.activeId = this.items[index].children[0].id;
                }
            },
            onItemClick(data) {
                if (data.categoryId) {
                    this.$router.push({path:'/m/data', query: { categoryId: data.id, title: data.text.replace("浏览", "")}})
                    //location.href = "/m/sort?categoryId=" + data.id + "&title=" + data.text.replace("浏览", "")
                } else {
                    this.$router.push({path:'/m/data', query: { brandId: data.id, title: data.text}})
                    //location.href = "/m/sort?brandId=" + data.id + "&title=" + data.text
                }
            },
            getCategoriesAndBrands () {
                this.$axios.get(window.consts.apis.categoriesAndBrands).then(res => {
                    if (res.success) {
                        //获取分类和商品品牌组合数据
                        this.getBrandsAndCategories(res.result);
                    }
                })
            },
            getBrandsAndCategories(result) {
                var brandList = [];
                for (var i in result) {
                    var item = result[i]
                    var temp = {};
                    temp.id = item.category.id;
                    temp.text = item.category.name;
                    temp.children = [];
                    for (var k in item.brands) {
                        var itemBrand = item.brands[k];
                        var tempBrand = {};
                        tempBrand.text = itemBrand.name;
                        tempBrand.id = itemBrand.id;
                        tempBrand.sort = itemBrand.sort;
                        temp.children.push(tempBrand);
                        brandList.push(tempBrand);
                    }
                    temp.children.sort((a, b) => {
                        return this._sort(a, b);
                    })
                    temp.children.unshift({ id: temp.id, text: "浏览" + temp.text, categoryId: temp.id })
                    this.items.push(temp);
                }
                if (result.length > 0 && result[0].brands.length > 0) {
                    this.activeId = this.items[0].children[0].id;
                }
                //商品去重
                var obj = {};
                this.brandList = brandList.reduce(function(item, next) {
                    obj[next.id] ? '' : obj[next.id] = true && item.push(next);
                    return item;
                }, []);
                this.brandList.sort((a, b) => {
                    return this._sort(a, b);
                })
            },
            closePopup() {
                this.$emit('closePopup', false);
            },
            _sort(a, b) {
                let sort = 0;
                if (a.sort < b.sort) {
                    sort = 1;
                } else if (a.sort > b.sort) {
                    sort = -1;
                } else {
                    if (a.id < b.id) {
                        sort = -1;
                    } else if (a.id > b.id) {
                        sort = 1;
                    }
                }
                return sort;
            }
        }

    }
</script>


